import React, {useMemo} from 'react'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import ReportSubtitleV1 from 'components/Text/ReportSubtitleV1'
import useLanguage from 'features/languageReport/useLanguage'
import useStyles from 'components/molcules/ProfitSummaryReport/useStyles'

export default function EEGSummaryOpinionAPI(props: {
  score: number
  index: number
  contourImage?: string
  isSummary?: boolean
}) {
  const {score, contourImage, index, isSummary} = props
  const {textEegAPI} = useLanguage('eeg')
  const classes = useStyles()

  const getNormativeI18n = useMemo(() => {
    const determineNormative = (score: number) => {
      if (score > 84)
        return textEegAPI?.brain_aging.basic.section.contour_graph.description
          .class.high
      if (score >= 16)
        return textEegAPI?.brain_aging.basic.section.contour_graph.description
          .class.normal
      return textEegAPI?.brain_aging.basic.section.contour_graph.description
        .class.low
    }
    return determineNormative(score)
  }, [score, textEegAPI])

  return (
    <div className={classes.eeg}>
      {isSummary ? (
        <ReportSubtitleV1 number={`${index}`}>
          {textEegAPI?.brain_aging.basic.section.contour_graph.title}
        </ReportSubtitleV1>
      ) : (
        <ReportSubtitle number={`${index}`}>
          {textEegAPI?.brain_aging.basic.section.contour_graph.title}
        </ReportSubtitle>
      )}
      {/* <div className={classes.brainOpinion}> */}

      <div className={classes.p_brainOpinion}>
        <div className='Detail'>
          <div className='Opinion' style={{fontSize: 17, fontWeight: 'bold'}}>
            {textEegAPI?.brain_aging.basic.section.contour_graph.description.main
              .replace('{0}', getNormativeI18n || '')
              .replace('{1}', score.toString())}
          </div>
          <div className='Reference'>
            <div style={{fontSize: 16}}>
              {
                textEegAPI?.brain_aging.basic.section.contour_graph.description
                  .sub
              }
            </div>
          </div>
        </div>
        <div className='Contour'>
          <img src={contourImage} alt='' className='Image' />
        </div>
      </div>
    </div>
  )
}
